__turbopack_context__.v({
  "btn_disabled": "CheckBox-module-scss-module__65xuMG__btn_disabled",
  "checkbox__wrapper": "CheckBox-module-scss-module__65xuMG__checkbox__wrapper",
});
